'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      position="top-right"
      expand={false}
      richColors={false}
      closeButton
      duration={3500}
      toastOptions={{
        classNames: {
          toast:
            'group toast bg-popover text-popover-foreground border border-border shadow-lg shadow-black/30 rounded-lg px-4 py-3 gap-3',
          title: 'text-sm font-semibold text-foreground',
          description: 'text-xs text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground hover:bg-primary/90',
          cancelButton: 'bg-muted text-muted-foreground hover:bg-muted/80',
          success: '!bg-success-light !border-success/30 !text-success',
          error: '!bg-danger-light !border-danger/30 !text-danger',
          warning: '!bg-warning-light !border-warning/30 !text-warning',
          info: '!bg-info-light !border-info/30 !text-info',
          icon: 'w-4 h-4',
        },
      }}
      {...props}
    />
  );
}
